(() => {
  if (window.PorterHillDispatchCountdown) {
    window.PorterHillDispatchCountdown.refresh();
    return;
  }

  const clock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hourCycle: 'h23'
  });
  const holidaysByYear = new Map();
  const pad = value => String(value).padStart(2, '0');
  const dateKey = date => date.toISOString().slice(0, 10);
  const addDays = (date, days) => new Date(date.getTime() + days * 86400000);
  const isWeekend = date => date.getUTCDay() === 0 || date.getUTCDay() === 6;

  function bankHolidays(year) {
    if (holidaysByYear.has(year)) return holidaysByYear.get(year);
    const days = new Set();
    let newYear = new Date(Date.UTC(year, 0, 1));
    while (isWeekend(newYear)) newYear = addDays(newYear, 1);
    days.add(dateKey(newYear));
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    const easter = new Date(Date.UTC(year, month - 1, day));
    days.add(dateKey(addDays(easter, -2)));
    days.add(dateKey(addDays(easter, 1)));
    const mayStart = new Date(Date.UTC(year, 4, 1));
    days.add(dateKey(addDays(mayStart, (8 - mayStart.getUTCDay()) % 7)));
    for (const monthIndex of [4, 7]) {
      const monthEnd = new Date(Date.UTC(year, monthIndex + 1, 0));
      days.add(dateKey(addDays(monthEnd, -((monthEnd.getUTCDay() + 6) % 7))));
    }
    const christmas = [25, 26].map(dayOfMonth => new Date(Date.UTC(year, 11, dayOfMonth)));
    christmas.forEach(date => days.add(dateKey(date)));
    for (const date of christmas) {
      if (!isWeekend(date)) continue;
      let substitute = addDays(date, 1);
      while (isWeekend(substitute) || days.has(dateKey(substitute))) substitute = addDays(substitute, 1);
      days.add(dateKey(substitute));
    }
    holidaysByYear.set(year, days);
    return days;
  }

  function dispatchState(now, closedDates = new Set()) {
    const parts = Object.fromEntries(clock.formatToParts(now).filter(part => part.type !== 'literal').map(part => [part.type, part.value]));
    const today = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
    const open = date => !isWeekend(date) && !bankHolidays(date.getUTCFullYear()).has(dateKey(date)) && !closedDates.has(dateKey(date));
    const secondsLeft = 16 * 3600 - Number(parts.hour) * 3600 - Number(parts.minute) * 60 - Number(parts.second);
    if (open(today) && secondsLeft > 0) return { today: true, secondsLeft };
    let next = addDays(today, 1);
    for (let count = 0; count < 370; count++, next = addDays(next, 1)) {
      if (open(next)) return { today: false, next, tomorrow: dateKey(next) === dateKey(addDays(today, 1)), daysAway: Math.round((next - today) / 86400000) };
    }
    return { today: false, next: null };
  }

  function replaceTokens(text, values) {
    for (const [key, value] of Object.entries(values)) text = text.split('[' + key + ']').join(String(value));
    return text;
  }

  function refresh() {
    const now = new Date();
    document.querySelectorAll('[data-ph-dispatch]').forEach(element => {
      const heading = element.querySelector('[data-ph-dispatch-heading]');
      const copy = element.querySelector('[data-ph-dispatch-text]');
      if (!heading || !copy) return;
      const labels = JSON.parse(element.dataset.phDispatchLabels);
      const closedDates = new Set((element.dataset.phDispatchClosedDates || '').split(/[\s,]+/).filter(Boolean));
      const state = dispatchState(now, closedDates);
      let title = labels.next_heading;
      let text = labels.fallback;
      let accessibleText = text;
      if (state.today) {
        const hours = Math.floor(state.secondsLeft / 3600);
        const minutes = Math.floor(state.secondsLeft % 3600 / 60);
        const seconds = state.secondsLeft % 60;
        title = labels.today_heading;
        text = replaceTokens(labels.countdown, { time: pad(hours) + ':' + pad(minutes) + ':' + pad(seconds) });
        accessibleText = replaceTokens(labels.accessible_countdown, { hours, minutes, seconds });
      }
      const link = element.closest('a');
      const href = state.today ? element.dataset.phDispatchDayLink : element.dataset.phDispatchShopLink;
      if (link && href && link.getAttribute('href') !== href) link.setAttribute('href', href);
      if (state.today) {
        element.setAttribute('title', element.dataset.phDispatchCutoffNote);
      } else {
        element.removeAttribute('title');
      }
      if (heading.textContent !== title) heading.textContent = title;
      if (copy.textContent !== text) copy.textContent = text;
      if (copy.getAttribute('aria-label') !== accessibleText) copy.setAttribute('aria-label', accessibleText);
    });
  }

  window.PorterHillDispatchCountdown = { refresh, dispatchState, bankHolidays };
  refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', refresh);
  let timer;
  function tick() {
    refresh();
    timer = window.setTimeout(tick, 1000 - Date.now() % 1000);
  }
  timer = window.setTimeout(tick, 1000 - Date.now() % 1000);
  window.addEventListener('pagehide', () => window.clearTimeout(timer));
  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      window.clearTimeout(timer);
      tick();
    }
  });
})();
